import IconArrow from '@/assets/icons/icon-arrow-top.svg'
import { ChartColors } from '@/components/charts/utils.ts'
import { Tooltip } from '@/components/ui/tooltip.tsx'
import { formatNumberWithPoints } from '@/utils/helpers.ts'

const ITEM_LIMIT = 4

export interface TotalDataOption {
  name: string
  value: number
  backgroundColor?: string
}

export interface SidebarChartLegendProps {
  legendData: {
    data: TotalDataOption[]
  }
}

export const SidebarChartLegend = ({ legendData }: SidebarChartLegendProps) => {
  const mainAccounts = legendData.data.slice(0, ITEM_LIMIT)
  const otherAccounts = legendData.data.slice(ITEM_LIMIT)

  return (
    <div className="flex w-60 flex-col gap-2">
      {mainAccounts.slice(0, 30).map((item, index) => (
        <div
          key={item.name}
          className="flex w-full justify-between text-sm font-medium text-text-default"
        >
          <div className="flex items-center gap-2">
            <div
              className="h-2 w-2 rounded-full"
              style={{
                backgroundColor:
                  item.backgroundColor ||
                  ChartColors[index % ChartColors.length],
              }}
            />
            <p>{item.name}</p>
          </div>
        </div>
      ))}
      <Tooltip
        side="bottom"
        content={otherAccounts.slice(0, 30).map((item, index) => (
          <div
            key={item.name}
            className="flex w-52 justify-between gap-2 text-sm font-medium"
          >
            <div className="flex items-center gap-2">
              <div
                className="h-2 w-2 rounded-full"
                style={{
                  backgroundColor:
                    item.backgroundColor ||
                    ChartColors[
                      (index + mainAccounts.length) % ChartColors.length
                    ],
                }}
              />
              <p>{item.name}</p>
            </div>
            <p className="justify-end text-text-sub">
              {formatNumberWithPoints(item.value)}
            </p>
          </div>
        ))}
      >
        {otherAccounts.length > 0 && (
          <div className="flex w-full justify-between text-sm font-medium">
            <div className="flex items-center gap-2">
              <IconArrow className="h-2 w-2 rotate-180" />
              <p>Other accounts</p>
            </div>
          </div>
        )}
      </Tooltip>
    </div>
  )
}
